import { genericColors } from './genericColors';

export const yellowTheme = {
  genericColors: { ...genericColors },
  themeColors: {
    controlBar: {
      background: genericColors.springWood,
      borderBottomColor: genericColors.grayDim,
      leftPanel: {
        goBackButtonColor: genericColors.gray,
        goBackButtonColorOnHover: genericColors.blueBright,
        goBackButtonColorOnActive: genericColors.blueMain,
        dividerColor: genericColors.grayLight,
        buttonColor: genericColors.grayDark,
        buttonColorOnHover: genericColors.blueBright,
        buttonColorOnActive: genericColors.blueMain,
      },
      rightPanel: {
        icons: {
          bookmarkIcon: {
            colorOnEmpty: genericColors.orangePeachy,
            colorOnEmptyAndHover: genericColors.orangeMain,
            colorOnFilled: genericColors.orangeMain,
            colorOnFilledAndHover: genericColors.orangeSoft,
          },
          bookshelfIcon: {
            booksIconColor: genericColors.gray,
            booksIconColorOnHover: genericColors.blueBright,
            circleBackground: genericColors.grayAlabaster,
            iconColor: genericColors.blueSeagull,
            iconColorOnActive: genericColors.blueMain,
          },
          settingsIcon: {
            color: genericColors.grayBoulder,
            colorOnHover: genericColors.blueBright,
            colorOnActive: genericColors.blueMain,
          },
          searchIcon: {
            color: genericColors.grayBoulder,
            colorOnHover: genericColors.blueBright,
            colorOnActive: genericColors.blueMain,
          },
        },
      },
    },
    settingsDropdown: {
      background: genericColors.springWood,
      borderColor: genericColors.grayLight,
      boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.25)',
      dividerColor: 'rgba(200, 200, 200, 0.5)',
      textColor: genericColors.grayDark,
      pageModeTogglerBorder: genericColors.grayLight,
      pageModeTogglerColor: genericColors.grayLight,
      oldReaderLinkColor: genericColors.blueMain,
      oldReaderLinkColorOnHover: genericColors.blueBright,
    },
    sidebars: {
      background: 'rgba(248, 244, 239, 0.95)',
      toc: {
        textColor: genericColors.blackMatt,
        subTextColor: genericColors.grayDark,
        dividerColor: genericColors.grayLight,
        itemColor: genericColors.blueMain,
        itemColorOnHover: genericColors.blueBright,
        itemColorOnActive: genericColors.blackMatt,
        itemBackgroundOnActive: 'rgba(106, 160, 241, 0.2)',
      },
      thumbnails: {
        textColor: genericColors.grayDark,
        textColorOnActive: genericColors.blackTotal,
      },
      bookmarks: {
        headerBackground: 'rgba(106, 160, 241, 0.2)',
        pagesColor: genericColors.blueMain,
        textColor: genericColors.blackMatt,
        dateColor: genericColors.grayDark,
        removeColor: genericColors.redMilano,
        dividerColor: 'rgba(200, 200, 200, 0.6)',
      },
    },
    pageContainer: { background: genericColors.sidecarYellow },
    footer: {
      background: genericColors.sidecarYellow,
      textColor: genericColors.blackTotal,
      progressBar: {
        trackColor: genericColors.grayLight,
      },
    },
    arrowButtons: {
      color: genericColors.gray,
      dropShadow: 'drop-shadow(4px 2px 6px rgba(0, 0, 0, 0.35))',
    },
    zoomButtons: {
      background: 'rgba(247, 245, 239, 0.95)',
      backgroundOnHover: genericColors.springWood,
      backgroundOnActive: genericColors.quarterSpanishOrange,
      borderColor: genericColors.grayDim,
      borderColorOnHover: genericColors.orangeDim,
      borderColorOnActive: genericColors.orangeDim,
      boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.1)',
      boxShadowOnHover: '0px 1px 6px rgba(252, 122, 30, 0.2)',
      iconColor: genericColors.grayLight,
      iconColorOnHover: genericColors.orangeMain,
      iconColorOnActive: genericColors.orangeMain,
    },
    beta: {
      button: {
        background: genericColors.springWood,
        backgroundOnHover: genericColors.springWood,
        backgroundOnActive: genericColors.quarterSpanishOrange,
        border: genericColors.grayDim,
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
        iconColor: genericColors.orangeLight,
        iconColorOnHover: genericColors.orangeSoft,
        iconColorOnActive: genericColors.orangeMain,
      },
      modal: {
        background: genericColors.springWood,
        borderColor: genericColors.grayLight,
        textColor: genericColors.blackTotal,
        smallTextColor: genericColors.grayBoulder,
        buttonBackground: genericColors.orangeSoft,
      },
    },
  },
  fontSizes: {
    base: '1rem',
    small: '0.88875rem',
    tiny: '0.79rem',
  },
  backgroundTransitionTime: '0.25s',
};
